// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__1Vdfk","labelContainer":"Slider_labelContainer__nRtxD","minLabel":"Slider_minLabel__I6PpI","maxLabel":"Slider_maxLabel__3--1V"};